if (CryptoJS) {
  var { enc, AES, mode, pad } = CryptoJS;
}
import { getFormattedMoney, parseAdminOrderResponse } from "//de.ringconn.com/cdn/shop/t/60/assets/theme.js?v=54494935086463417971792465359";
// 常量定义
const CONSTANTS = {
  AES_KEY: "c4312b5bf6b2dabf3fe54396b8bfe7c0",
  respKey: "482a7567f75b83294277b9366ed2a773",
  DEFAULT_AMOUNT: "90",
  API_PATH: "/admin/order/RingPartExchangeCouponGet",
  GEN1_API_PATH: "/admin/order/RingPartExchangeCheckGen1",
  CLIENT_INFO: {
    languageCode: window?.ShopifyInfo?.language || "en",
  },
  "ringconntest.myshopify.com": {
    2099: "44607420072189",
    "3099JP": "45779124027645",
    3099: "45779124027645",
    4099: "46100545896701",
    JP4099: "46100545896701",
    GEN3999: "47282885067005",
    JPGEN3999: "47282978586877",
  },
  "ringconn.com": {
    2099: "47501231161652",
    3099: "48229182996788",
    "3099JP": "48229182996788",
    4099: "48494923481396",
    GEN3999: "49061933613364",
  },
  "ringconn.jp": {
    JP3099: "46502331547822",
    "3099JP": "46502331547822",
    JP4099: "47098234994862",
    GEN3999: "47282885067005",
    JPGEN3999: "47629397819566",
  },
  "de.ringconn.com": {
    2099: "43083351326831",
    3099: "43083351392367",
    4099: "43083351523439",
    GEN3999: "52805733023855",
  },
};

class TradeIn extends HTMLElement {
  static CHECKOUT_RETURN_KEY = "ringconn:tradein-checkout";

  constructor() {
    super();
    this._initialized = false;
    this._checkoutGeneration = 0;
  }
  connectedCallback() {
    this._bindPageLifecycle();
    // 解析器可能在子节点就绪前触发 connectedCallback，延后一拍再查 DOM
    if (this._initialized) return;
    queueMicrotask(() => {
      if (!this.isConnected || this._initialized) return;
      this.init();
    });
  }

  disconnectedCallback() {
    this._unbindPageLifecycle();
    this._checkoutAbort?.abort();
  }

  // 初始化方法
  init() {
    // 初始化元素引用
    this.errorTips = window.checkingRule?.errorTips;
    // this.selectDeviceBtn = this.querySelector(".trade-in-btn");
    // this.noTradeInBtn = this.querySelector(".no-trade-in");
    this.deviceList = this.querySelector(".device-list");
    this.customSelect = this.querySelector(".device_select");
    this.selectSelected = this.querySelector(".select-selected");
    this.selectItems = this.querySelector(".select-items");
    this.deviceVariant = this.querySelector(".device-variant");
    this.emailField = this.querySelector(".email-field");
    this.snField = this.querySelector(".sn-field");
    this.snSubmitBtn = this.querySelector(".sn-submit-btn");
    this.errorMessages = this.querySelector(".error-message");
    this.tradeInForm = this.querySelector(".trade-in-form");
    this.tradeInError = this.querySelector(".trade-in-error");
    this.successElement = this.querySelector(".trade-in-success");

    // 初始化 trade_drawer 引用
    this.trade_drawer = document.querySelector("x-drawer.trade_drawer.trade_size_chart_page");

    // 子节点偶发未就绪时再等一帧；仍缺失则由 setupDropdownEvents 空值防护兜底
    if (!this.selectSelected && !this._initRetried) {
      this._initRetried = true;
      requestAnimationFrame(() => {
        if (this.isConnected && !this._initialized) this.init();
      });
      return;
    }

    this.setupEventListeners();
    this._initialized = true;
    queueMicrotask(() => this._syncBuyButtonMode());  }

  // ===== 加密解密相关方法 =====

  encrypted(data) {
    console.log(data, "encrypted");
    const aesKey = enc.Utf8.parse(CONSTANTS.AES_KEY);
    const jsonStr = JSON.stringify(JSON.parse(JSON.stringify(data)));
    const base64Encoded = btoa(jsonStr);
    return this.aesEncrypt(base64Encoded, aesKey);
  }

  aesEncrypt(plaintext, key) {
    const encrypted = AES.encrypt(plaintext, key, {
      mode: mode.ECB,
      padding: pad.Pkcs7,
    });
    return encrypted.ciphertext.toString(enc.Base64);
  }

  decrypted(encryptedBase64) {
    const aesKey = enc.Utf8.parse(CONSTANTS.respKey);
    const decryptedBase64 = this.aesDecrypt(encryptedBase64, aesKey);
    const originalJson = atob(decryptedBase64);
    return JSON.parse(originalJson);
  }

  aesDecrypt(ciphertext, key) {
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: enc.Base64.parse(ciphertext),
    });
    const decrypted = AES.decrypt(cipherParams, key, {
      mode: mode.ECB,
      padding: pad.Pkcs7,
    });
    return decrypted.toString(enc.Utf8);
  }

  // ===== 事件处理相关方法 =====

  setupEventListeners() {
    // 设备选择按钮事件
    // this.selectDeviceBtn.addEventListener("click", () => this.toggleDeviceList(true));
    // this.noTradeInBtn.addEventListener("click", () => this.toggleDeviceList(false));

    // 下拉菜单事件
    this.setupDropdownEvents();

    // 表单输入事件
    this.setupFormEvents();
  }

  setupDropdownEvents() {
    if (!this.selectSelected || !this.selectItems || !this.customSelect) return;

    this._dropdownOptions = Array.from(this.selectItems.querySelectorAll(".select-item"));
    this._dropdownActiveIndex = -1;

    this.selectSelected.addEventListener("click", () => this._toggleDropdown());
    this.selectSelected.addEventListener("keydown", (event) => this._onDropdownKeydown(event));

    document.addEventListener("click", (e) => {
      if (!this.customSelect?.contains(e.target)) this._closeDropdown();
    });
    this._dropdownEscapeHandler = (event) => {
      if (event.key === "Escape") this._closeDropdown();
    };
    document.addEventListener("keydown", this._dropdownEscapeHandler);

    this._dropdownOptions.forEach((item, index) => {
      item.addEventListener("click", () => {
        this._selectDropdownOption(index);
      });
      item.addEventListener("focus", () => {
        this._dropdownActiveIndex = index;
      });
      item.addEventListener("keydown", (event) => this._onOptionKeydown(event, index));
    });
  }

  _syncDropdownOptionTabindex(isOpen) {
    this._dropdownOptions?.forEach((item, index) => {
      item.setAttribute("tabindex", isOpen ? "0" : "-1");
      if (isOpen) {
        item.setAttribute("aria-selected", index === this._dropdownActiveIndex ? "true" : "false");
      }
    });
  }

  _toggleDropdown(forceOpen) {
    if (!this.customSelect || !this.selectSelected) return;
    const willOpen = typeof forceOpen === "boolean" ? forceOpen : !this.customSelect.classList.contains("active");
    this.customSelect.classList.toggle("active", willOpen);
    this.selectSelected.setAttribute("aria-expanded", willOpen ? "true" : "false");
    if (willOpen && this._dropdownOptions?.length > 0) {
      this._dropdownActiveIndex = Math.max(this._dropdownActiveIndex, 0);
      this._syncDropdownOptionTabindex(true);
      this._dropdownOptions[this._dropdownActiveIndex]?.focus();
    } else {
      this._syncDropdownOptionTabindex(false);
    }
  }

  _closeDropdown() {
    if (!this.customSelect || !this.selectSelected) return;
    this.customSelect.classList.remove("active");
    this.selectSelected.setAttribute("aria-expanded", "false");
    this._dropdownActiveIndex = -1;
    this._syncDropdownOptionTabindex(false);
  }

  _onDropdownKeydown(event) {
    if (!this.customSelect) return;
    const { key } = event;
    const isOpen = this.customSelect.classList.contains("active");

    if (key === "Enter" || key === " " || key === "ArrowDown" || key === "ArrowUp") {
      event.preventDefault();
      if (!isOpen) {
        this._toggleDropdown(true);
        return;
      }
    }

    if (!isOpen) return;

    if (key === "Escape") {
      event.preventDefault();
      this._closeDropdown();
      this.selectSelected?.focus();
      return;
    }

    if (key === "ArrowDown") {
      event.preventDefault();
      this._dropdownActiveIndex = (this._dropdownActiveIndex + 1) % this._dropdownOptions.length;
      this._dropdownOptions[this._dropdownActiveIndex]?.focus();
      return;
    }

    if (key === "ArrowUp") {
      event.preventDefault();
      this._dropdownActiveIndex =
        (this._dropdownActiveIndex - 1 + this._dropdownOptions.length) % this._dropdownOptions.length;
      this._dropdownOptions[this._dropdownActiveIndex]?.focus();
      return;
    }

    if (key === "Enter" || key === " ") {
      event.preventDefault();
      if (this._dropdownActiveIndex >= 0) {
        this._selectDropdownOption(this._dropdownActiveIndex);
      }
    }
  }

  _onOptionKeydown(event, index) {
    const { key } = event;
    if (key === "Enter" || key === " ") {
      event.preventDefault();
      event.stopPropagation();
      this._selectDropdownOption(index);
      return;
    }
    if (key === "Escape" || key === "ArrowDown" || key === "ArrowUp") {
      this._onDropdownKeydown(event);
    }
  }

  _selectDropdownOption(index) {
    const item = this._dropdownOptions?.[index];
    if (!item || !this.selectSelected) return;

    const { value, type, title, price, image } = item.dataset;
    this.clearinput();
    this.selectSelected.innerHTML = "";

    if (image) {
      const imgElement = document.createElement("img");
      imgElement.src = image;
      imgElement.alt = title;
      imgElement.className = "selected-device-image";
      this.selectSelected.appendChild(imgElement);
    }

    const infoContainer = document.createElement("div");
    infoContainer.className = "selected-device-info";

    const nameElement = document.createElement("div");
    nameElement.className = "selected-device-name";
    nameElement.textContent = title;
    infoContainer.appendChild(nameElement);

    const priceElement = document.createElement("div");
    priceElement.className = "selected-device-price";
    priceElement.innerHTML = getFormattedMoney(price);
    infoContainer.appendChild(priceElement);

    this.selectSelected.appendChild(infoContainer);
    this.selectSelected.dataset.value = value;
    this.selectSelected.dataset.price = price;
    this.selectSelected.dataset.type = type;
    this._closeDropdown();
    this.selectSelected.focus();

    this.handleDeviceSelect(type);
    const trade_Gen1 = document.querySelector(".trade_drawer_content .RingConn1");
    const trade_competitor = document.querySelector(".trade_drawer_content .competitor");
    const trade_competitor2 = document.querySelector(".drawer_tradein_content");
    if (type == 1) {
      if (trade_Gen1) trade_Gen1.style.display = "block";
      if (trade_competitor) trade_competitor.style.display = "none";
      if (trade_competitor2) trade_competitor2.style.display = "none";
    } else {
      if (trade_competitor) trade_competitor.style.display = "block";
      if (trade_competitor2) trade_competitor2.style.display = "grid";
      if (trade_Gen1) trade_Gen1.style.display = "none";
    }

    this.selectItems?.querySelectorAll(".select-item").forEach((option) => {
      option.classList.remove("active");
    });
    item.classList.add("active");
    this._dropdownActiveIndex = index;
  }
  setupFormEvents() {
    const emailInput = this.querySelector('input[type="email"]');
    if (emailInput) {
      emailInput.addEventListener("input", (e) => {
        // 实时验证邮箱格式
        this.validateEmail(e.target);
      });
    }

    const snInput = this.querySelector('input[name="trade_sn"]');
    if (snInput) {
      snInput.addEventListener("input", (e) => {
        // 实时验证 SN 格式
        if (!this.validateSN(e.target)) return;
        this.updateSubmitButtonState();
      });
    }

    if (this.snSubmitBtn) {
      this.snSubmitBtn.addEventListener("click", () => this.handleSubmit());
      this.syncSnSubmitButtonFocus();
    }
  }

  /** Safari：SN「Entregar」需显式 tabindex=0（不在 x-drawer 内，不走 syncDrawerAllTabStops） */
  syncSnSubmitButtonFocus() {
    if (!this.snSubmitBtn) return;

    const enabled = !this.snSubmitBtn.disabled;
    const snVisible = this.snField && this.snField.style.display !== "none";

    if (enabled && snVisible) {
      this.snSubmitBtn.setAttribute("tabindex", "0");
      this.snSubmitBtn.tabIndex = 0;
    } else {
      this.snSubmitBtn.setAttribute("tabindex", "-1");
      this.snSubmitBtn.tabIndex = -1;
    }

    const openDrawer = this.closest("x-drawer[open], x-popover[open]");
    if (openDrawer && window.A11yLinkKeyboard?.syncDrawerTabStops) {
      window.A11yLinkKeyboard.syncDrawerTabStops(openDrawer);
    }
  }
  toggleDeviceList(show) {
    if (show) {
      // this.selectDeviceBtn.classList.add("active");
      // this.noTradeInBtn.classList.remove("active");
      this.deviceList.classList.add("active");
      this.deviceList.style.display = "flex";
      const tradeinIdInput = this.querySelector('input[name="tradein-device"]');
      if (tradeinIdInput) {
        tradeinIdInput.value = "";
        tradeinIdInput.dataset.devicePrice = "";
        document.dispatchEvent(new CustomEvent("tradein:change"));
      }
    } else {
      this.handleEditButtonClick();
      this.resetForm();
    }
    this.tradeInError.style.display = "none";
  }

  handleDeviceSelect(deviceValue) {
    // 重置设备变体状态
    this.resetDeviceVariant();
    if (!deviceValue) return;
    // 设置新的设备变体状态
    this.setDeviceVariant(deviceValue);

    // 查找并应用设备配置
    this.applyDeviceConfig(deviceValue);
    this.updateSubmitButtonState();
    document.dispatchEvent(new CustomEvent("tradein:change"));
  }

  resetDeviceVariant() {
    if (!this.deviceVariant) return;
    this.deviceVariant.style.display = "none";
    this.deviceVariant.removeAttribute("data-active");
  }

  setDeviceVariant(deviceValue) {
    if (!this.deviceVariant) return;
    this.deviceVariant.dataset.device = deviceValue;
    this.deviceVariant.style.display = "flex";
    this.deviceVariant.setAttribute("data-active", "true");
  }

  applyDeviceConfig(deviceValue) {    const selectedDevice = window.checkingRule.childeList.find((device) => device.type == deviceValue);
    if (!selectedDevice) return;

    // 更新类型输入
    const typeInput = this.querySelector('input[name="type"]');
    if (typeInput) typeInput.value = selectedDevice.type;

    // 更新字段显示
    this.updateFieldVisibility(selectedDevice);
  }

  updateFieldVisibility(device) {
    if (this.emailField) {
      this.emailField.style.display = device.showEmail ? "block" : "none";
      this.snSubmitBtn.style.display = device.showEmail ? "none" : "flex";
      this.emailField.addEventListener("click", (e) => {
        this.emailField.querySelector(".input-field").classList.add("active");
      });
    }

    if (this.snField) {
      this.snField.style.display = device.showSn ? "block" : "none";
      const tips = (this.tips = this.snField.querySelector(".tips"));
      if (tips) tips.textContent = device.tips || "";
      this.snField.addEventListener("click", (e) => {
        this.snField.querySelector(".input-field").classList.add("active");
      });
    }
    this.syncSnSubmitButtonFocus();
  }

  updateSubmitButtonState() {
    if (!this.snSubmitBtn) return;

    const emailField = this.querySelector(".email-field");
    const emailInput = this.querySelector('input[type="email"]');
    const snInput = this.querySelector('input[name="trade_sn"]');

    const isEmailValid = emailField.style.display === "none" || this.validateEmailFormat(emailInput);
    const isSnValid = snInput && snInput.value.trim();

    this.snSubmitBtn.disabled = !isEmailValid || !isSnValid;
    this.syncSnSubmitButtonFocus();
  }

  // ===== API 交互方法 =====

  // 在 TradeIn 类中添加 open 方法
  open() {
    if (!this.trade_drawer) {
      console.error("Trade drawer not found");
      return;
    }

    const overlay = this.trade_drawer.shadowRoot.querySelector('div[part="overlay"]');
    if (overlay) {
      overlay.style.display = "block";
    }
    this.trade_drawer.show();
    this.trade_drawer.setAttribute("open", "");

    // 设置垂直居中
    const height = this.trade_drawer.offsetHeight;
    const type = this.querySelector('.trade-in-form input[name="type"]').value || 1;
    this.trade_drawer.style.top = `0`;
  }

  closeDrawer() {
    if (!this.trade_drawer) return;
    if (typeof this.trade_drawer.hide === "function") {
      this.trade_drawer.hide();
    } else {
      this.trade_drawer.removeAttribute("open");
      const overlay = this.trade_drawer.shadowRoot?.querySelector('div[part="overlay"]');
      if (overlay) overlay.style.display = "none";
    }
  }

  // 与 theme.js CustomButton 相同的三点 loader；Safari 不支持 customized built-in 时走 CSS 兜底
  ensureButtonLoader(button) {
    if (!button || button.querySelector(".button__loader")) return;
    const loader = document.createRange().createContextualFragment(`
      <span class="button__loader">
        <span></span>
        <span></span>
        <span></span>
      </span>
    `).firstElementChild;
    const content = document.createElement("div");
    content.append(...button.childNodes);
    button.append(content, loader);
  }

  upgradeDrawerSubmitButton() {
    const existing = this.trade_drawer?.querySelector(".trade_button");
    if (!existing) return null;
    if (existing.dataset.tradeCustomButton === "true") {
      this.ensureButtonLoader(existing);
      return existing;
    }

    const upgraded = document.createElement("button", { is: "custom-button" });
    upgraded.className = existing.className;
    upgraded.setAttribute("type", "button");
    upgraded.setAttribute("is", "custom-button");
    upgraded.dataset.tradeCustomButton = "true";
    if (upgraded.contentElement) {
      upgraded.contentElement.append(...existing.childNodes);
    } else {
      upgraded.append(...existing.childNodes);
      this.ensureButtonLoader(upgraded);
    }
    existing.replaceWith(upgraded);
    return upgraded;
  }

  setButtonLoading(button, loading) {
    if (!button) return;
    if (loading) {
      button.setAttribute("aria-busy", "true");
      button.disabled = true;
    } else {
      button.removeAttribute("aria-busy");
      button.disabled = false;
      button.removeAttribute("disabled");
    }
  }

  _bindPageLifecycle() {
    if (this._pageLifecycleBound) return;
    this._pageLifecycleBound = true;
    window.addEventListener("pageshow", this._onPageShow);
    window.addEventListener("pagehide", this._onPageHide);
    document.addEventListener("variant:change", this._onVariantChangedForBuyButton);
  }

  _unbindPageLifecycle() {
    if (!this._pageLifecycleBound) return;
    this._pageLifecycleBound = false;
    window.removeEventListener("pageshow", this._onPageShow);
    window.removeEventListener("pagehide", this._onPageHide);
    document.removeEventListener("variant:change", this._onVariantChangedForBuyButton);
  }

  _onVariantChangedForBuyButton = (event) => {
    const variant = event.detail?.variant;
    if (!variant?.available) return;
    queueMicrotask(() => this._syncBuyButtonMode());
  };

  _isTradeInSelected() {
    const coupon = this.querySelector('input[name="tradein-device"]')?.value;
    if (coupon) return true;
    const selected = this.selectSelected || this.querySelector(".select-selected");
    if (!selected) return false;
    const placeholder = (selected.getAttribute("data-placeholder") || "").trim();
    const chosen = (selected.textContent || "").replace(/\s+/g, " ").trim();
    return Boolean(selected.dataset.type) || (Boolean(chosen) && chosen !== placeholder);
  }

  _buyButtonLabelEl(button) {
    return button?.getAttribute("is") === "custom-button" ? button.firstElementChild : button;
  }

  _syncBuyButtonMode() {
    if (this._isTradeInSelected()) {
      this._setTradeInBuyButtonLabel();
      return;
    }
    this._restoreAddToCartButtons();
  }

  _restoreAddToCartButtons() {
    const label = window.themeVariables?.strings?.addToCartButton || "Add to cart";
    const tradeInButton = document.querySelector(".trade-in-button");
    if (tradeInButton && this.originalButton && tradeInButton !== this.originalButton) {
      tradeInButton.parentNode.replaceChild(this.originalButton, tradeInButton);
    }
    document.querySelectorAll("buy-buttons button[type='submit'], .product-info__buy-buttons button[type='submit']").forEach((button) => {
      if (button.disabled) return;
      button.classList.remove("trade-in-button", "trade-in-submit");
      delete button.dataset.buttonText;
      const textEl = this._buyButtonLabelEl(button);
      const copy = (textEl?.textContent || "").replace(/\s+/g, " ").trim();
      if (/buy now|buy it now|立即购买|今すぐ購入/i.test(copy) && textEl) {
        textEl.textContent = label;
      }
    });
  }

  _setTradeInBuyButtonLabel(button = document.querySelector(".trade-in-button")) {
    if (!this._isTradeInSelected()) {
      this._restoreAddToCartButtons();
      return;
    }
    if (!button) return;
    const label = button.dataset.buttonText || this.dataset.buttonText || "buy now";
    const textEl = this._buyButtonLabelEl(button);
    if (textEl) textEl.textContent = label;
  }

  _onPageHide = (event) => {
    // iOS Safari 会把 PDP 冻进 bfcache；冻之前先解开按钮，返回后才能再点
    if (event.persisted) this._restoreAfterCheckoutReturn();
  };

  _onPageShow = (event) => {
    let fromTradeInCheckout = false;
    try {
      fromTradeInCheckout = sessionStorage.getItem(TradeIn.CHECKOUT_RETURN_KEY) === "1";
    } catch (error) {
      /* Safari private mode */
    }
    const buyButton = document.querySelector(".trade-in-button");
    const isBusy = !!buyButton && (buyButton.disabled || buyButton.getAttribute("aria-busy") === "true");
    if (event.persisted || fromTradeInCheckout || isBusy) {
      this._restoreAfterCheckoutReturn();
    }
  };

  _restoreAfterCheckoutReturn() {
    this._checkoutGeneration += 1;
    this._checkoutAbort?.abort();
    this._checkoutAbort = null;
    this._submitting = false;

    const buyButton = document.querySelector(".trade-in-button");
    this.setButtonLoading(buyButton, false);
    this._setTradeInBuyButtonLabel(buyButton);

    const drawerButton = this.trade_drawer?.querySelector(".trade_button");
    this.setDrawerSubmitLoading(drawerButton, false);

    const productForm =
      buyButton?.form ||
      document.querySelector('form[is="product-form"]') ||
      document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      delete productForm.dataset.checkoutDiscount;
      delete productForm.dataset.tradeInCheckout;
    }

    try {
      sessionStorage.removeItem(TradeIn.CHECKOUT_RETURN_KEY);
    } catch (error) {
      /* Safari private mode */
    }

    this.closeDrawer();
    this._closeDropdown();
  }

  setDrawerSubmitLoading(button, loading) {
    this.setButtonLoading(button, loading);
  }

  upgradeTradeInBuyButton(originalButton) {
    if (!originalButton) return null;
    const upgraded = document.createElement("button", { is: "custom-button" });
    upgraded.className = "button button--xl trade-in-button";
    upgraded.setAttribute("type", "submit");
    upgraded.setAttribute("is", "custom-button");
    upgraded.classList.add("trade-in-submit");
    upgraded.dataset.tradeCustomButton = "true";
    const buttonLabel = this.dataset.buttonText || "buy now";
    upgraded.dataset.buttonText = buttonLabel;
    if (upgraded.contentElement) {
      upgraded.contentElement.textContent = buttonLabel;
    } else {
      upgraded.textContent = buttonLabel;
      this.ensureButtonLoader(upgraded);
    }
    originalButton.parentNode.replaceChild(upgraded, originalButton);
    return upgraded;
  }

  bindDrawerEvents() {
    if (!this.trade_drawer || this._drawerEventsBound) return;
    this._drawerEventsBound = true;

    const submitButton = this.upgradeDrawerSubmitButton();
    if (submitButton) {
      submitButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.submitTradeInForm();
      });
    }

    const closeButton = this.trade_drawer.querySelector('button[part="close-button"]');
    if (closeButton) {
      closeButton.addEventListener("click", () => this.closeDrawer());
    }
  }

  // 修改 handleSubmit 方法
  async handleSubmit() {
    console.log(this.selectSelected.dataset.type, "this.selectSelected.dataset.type");
    let ringconngenlist = [1, 12, 13];
    if (this.selectSelected.dataset.type && ringconngenlist.includes(Number(this.selectSelected.dataset.type))) {
      this.tradeInError.style.display = "none";
      const isPass = await this.submitTradeInForGen1();
      if (!isPass) return;
    }
    // 打开弹窗而不是直接提交
    this.open();
    this.tradeInError.style.display = "none";
    this.bindDrawerEvents();
  }

  // gen1 接口调用提前
  async submitTradeInForGen1() {
    this.snSubmitBtn.disabled = true;
    const formData = this.collectFormData();
    console.log(formData, "formData");
    if (!formData) return;
    try {
      const checkResponse = await this.sendApiRequest(formData, CONSTANTS.GEN1_API_PATH);
      if (checkResponse.code !== 0) {
        let errorMsg = checkResponse.msg;
        this.showApiError(errorMsg || "提交失败，请稍后重试");
        return false;
      }
      return true;
    } catch (error) {
      console.error("请求错误:", error);
    } finally {
      this.snSubmitBtn.disabled = false;
    }
  }

  // 修改 submitTradeInForm 方法
  async submitTradeInForm() {
    if (this._submitting) return;
    const formData = this.collectFormData();
    if (!formData || !this.trade_drawer) return;

    const submitButton = this.trade_drawer.querySelector(".trade_button");
    this._submitting = true;
    this.setDrawerSubmitLoading(submitButton, true);

    try {
      const response = await this.sendApiRequest(formData);
      const ok = this.handleApiResponse(response);
      this.closeDrawer();      if (!ok) return;
    } catch (error) {
      console.error("请求错误:", error);
      this.closeDrawer();
      this.showApiError(this.errorTips?.serverError || "提交失败，请稍后重试");
    } finally {
      this._submitting = false;
      this.setDrawerSubmitLoading(submitButton, false);
    }
  }

  // 添加收集表单数据的辅助方法
  collectFormData() {
    const snInput = this.querySelector('input[name="trade_sn"]');
    if (!snInput) return null;

    return {
      sn: snInput.value.trim(),
      email: this.querySelector('input[type="email"]')?.value || undefined,
      type: Number(this.querySelector('input[name="type"]')?.value) || undefined,
      productId: this.querySelector('input[name="productId"]')?.value || undefined,
      webSite: window?.ShopifyInfo?.webSite || "GB",
    };
  }

  async sendApiRequest(formData, apiPath = CONSTANTS.API_PATH) {
    console.log(formData, "formData");
    const payload = {
      client: {
        languageCode: window?.ShopifyInfo?.language || "en",
      },
      payload: {
        businessData: this.encrypted(formData),
      },
    };

    // 判断域名并设置API URL
    const apiDomain = window.location.hostname.includes("test") ? "dev.oms" : "oms";
    const apiUrl = `https://${apiDomain}.gdjztech.com${apiPath}`;

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    // 公共 404 兜底（assets/theme.js.liquid），返回 {code, msg} 结构，
    // handleApiResponse / submitTradeInForGen1 现有的失败分支会直接展示 msg
    return parseAdminOrderResponse(response);
  }

  handleApiResponse(data) {
    if (data.code === 0) {
      const { resultData } = data?.payload;
      const decryptedData = this.decrypted(resultData);

      // 检查是否包含折扣码
      if (decryptedData && decryptedData.exchangeCouponCode) {
        // 显示成功UI
        this.showTradeInSuccess(decryptedData);
        return true;
      }
      this.showApiError(this.errorTips?.serverError || "提交失败，请稍后重试");
      return false;
    }

    let errorMsg = data.msg;
    if (data.code == 80100) {
      errorMsg = data.msg + this.querySelector(".tips-error").dataset.msg;
    }
    this.showApiError(errorMsg || "提交失败，请稍后重试");
    return false;
  }

  showApiError(message = "") {
    const container = this.querySelector(".tips-error .error-message-container");
    if (!container) return;

    // 移除已有的错误消息
    const existingError = container.querySelector(".error-message");
    const error_checkmark = this.querySelector(".trade-in-form .error_checkmark");
    const tips = this.snField?.querySelector(".tips");
    if (existingError) {
      existingError.remove();
      if (error_checkmark) error_checkmark.style.display = "none";
    }

    // 创建新的错误消息
    const errorElement = document.createElement("div");
    errorElement.className = "error-message";
    errorElement.setAttribute("data-api-error", "true");
    errorElement.innerHTML = message;
    errorElement.style.display = "block";
    container.appendChild(errorElement);
    if (message != "") {
      if (error_checkmark) error_checkmark.style.display = "inline-block";
      if (tips) tips.style.display = "none";
    } else {
      if (error_checkmark) error_checkmark.style.display = "none";
      if (tips) tips.style.display = "block";
    }
  }

  // ===== 成功UI展示方法 =====

  showTradeInSuccess(data) {
    // 隐藏设备列表和输入表单
    this.deviceList.style.display = "none";

    // 显示成功UI
    if (this.successElement) {
      this.updateSuccessUI(data);
      this.setupEditButton();

      // 添加价格计算逻辑
      this.updateProductPrice(data);
    }

    // 隐藏错误信息
  }
  getDiscount() {
    const price = this.querySelector(".select-selected").dataset.price;
    return price?.replace("$", "") || null;
  }
  async updateProductPrice(data) {
    if (!data?.exchangeCouponCode) {      document.dispatchEvent(new CustomEvent("tradein:change"));
      return;
    }
    this.storeTradeInData(data);
  }

  clearTradeInData() {
    const tradeinIdInput = this.querySelector('input[name="tradein-device"]');
    if (!tradeinIdInput) return;
    tradeinIdInput.value = "";
    tradeinIdInput.dataset.devicePrice = "";    document.dispatchEvent(new CustomEvent("tradein:change"));
  }
  updateSuccessUI(data) {
    // 更新设备名称
    const deviceName = this.successElement.querySelector(".device-name");
    console.log(deviceName, "deviceName", this.selectSelected.textContent);
    if (deviceName) deviceName.textContent = this.selectSelected.textContent;

    // 更新折扣金额
    const tradeInValue = this.successElement.querySelector(".trade-in-value");
    if (tradeInValue) {
      tradeInValue.innerHTML = getFormattedMoney(this.getDiscount(), false);
    }

    // 显示成功UI
    this.successElement.style.display = "block";

    // 修改购买按钮
    this.updateBuyButton(data);
  }

  getSku(sku) {
    const data = CONSTANTS[window?.ShopifyInfo?.shopDomain || window.location.host];
    return data[sku];
  }
  base64url(json) {
    const properties = JSON.stringify(json);
    const base64 = btoa(unescape(encodeURIComponent(properties)));
    const base64url = base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    return base64url;
  }

  // 添加新方法用于更新购买按钮
  updateBuyButton(data) {
    // 查找原始的购买按钮
    this.originalButton = document.querySelector('.product-info__buy-buttons .button[type="submit"]');
    if (!this.originalButton) return;
    const newButton = this.upgradeTradeInBuyButton(this.originalButton);

    // 获取折扣码
    const discountCode = data?.exchangeCouponCode || "";

    // 添加点击事件处理
    newButton.addEventListener("click", async (e) => {
      e.preventDefault();
      if (newButton.disabled || newButton.getAttribute("aria-busy") === "true") return;

      const productForm =
        newButton.form ||
        document.querySelector('form[is="product-form"]') ||
        document.querySelector('form[action*="/cart/add"]');
      if (!productForm) {
        console.error("Product form 不存在");
        return;
      }

      this._checkoutAbort?.abort();
      this._checkoutAbort = new AbortController();
      const { signal } = this._checkoutAbort;
      const generation = ++this._checkoutGeneration;

      this.setButtonLoading(newButton, true);      try {
        const clearRes = await fetch(`${window.Shopify?.routes?.root || "/"}cart/clear.js`, {
          method: "POST",
          signal,
        });
        if (generation !== this._checkoutGeneration) return;
        if (!clearRes.ok) throw new Error("clear cart failed");
        if (typeof cardlist !== "undefined") cardlist = [];

        if (discountCode) productForm.dataset.checkoutDiscount = discountCode;
        productForm.dataset.tradeInCheckout = "true";

        const email = this.querySelector('input[type="email"]')?.value || "";
        const onAdded = (event) => {          if (generation !== this._checkoutGeneration) return;
          event.preventDefault();
          if (event.detail) event.detail.blockCartDrawerOpening = true;
          window.PromoGiftPicker?.resetAll?.();
          try {
            sessionStorage.setItem(TradeIn.CHECKOUT_RETURN_KEY, "1");
          } catch (error) {
            /* Safari private mode */
          }
          const query = [];
          if (discountCode) query.push(`discount=${encodeURIComponent(discountCode)}`);
          if (email) query.push(`checkout[email]=${encodeURIComponent(email)}`);
          window.location.href = query.length ? `/checkout?${query.join("&")}` : "/checkout";
        };
        const onError = () => {
          if (generation !== this._checkoutGeneration) return;
          delete productForm.dataset.checkoutDiscount;
          delete productForm.dataset.tradeInCheckout;
          this.setButtonLoading(newButton, false);
        };
        productForm.addEventListener("variant:add", onAdded, { once: true, signal });
        productForm.addEventListener("cart:error", onError, { once: true, signal });

        if (typeof productForm.requestSubmit === "function") {
          productForm.requestSubmit();
        } else {
          productForm.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
        }
      } catch (err) {
        if (err?.name === "AbortError") return;
        console.error("Trade-in checkout 失败:", err);
        if (generation !== this._checkoutGeneration) return;
        delete productForm.dataset.checkoutDiscount;
        delete productForm.dataset.tradeInCheckout;
        this.setButtonLoading(newButton, false);
      }
    });
  }

  setupEditButton() {
    const editBtn = this.successElement.querySelector(".edit-btn");
    if (editBtn) {
      editBtn.onclick = () => {
        this.handleEditButtonClick();
        this.toggleDeviceList(true);
      };
    }
  }

  handleEditButtonClick() {
    // 隐藏成功UI
    this.successElement.style.display = "none";
    // 重置所有状态
    this.resetAllState();
    // this.selectDeviceBtn.classList.remove("active");
    // this.noTradeInBtn.classList.add("active");
    this.deviceList.classList.remove("active");
    this.deviceList.style.display = "none";
    this.deviceVariant.style.display = "none";
    this.clearTradeInData();
  }

  resetAllState() {
    // 重置表单和选择

    this.resetForm();

    // 清空设备变体数据
    this.deviceVariant.style.display = "none";
    this.deviceVariant.removeAttribute("data-active");
    this.deviceVariant.removeAttribute("data-device");

    // 清空输入框
    this.clearinput();
    // 恢复原始购买按钮
    const tradeInButton = document.querySelector(".trade-in-button");
    if (tradeInButton && this.originalButton) {
      tradeInButton.parentNode.replaceChild(this.originalButton, tradeInButton);
    }
    this._syncBuyButtonMode();
  }
  clearinput() {    const emailInput = this.querySelector('input[type="email"]');
    this.showApiError("");
    if (emailInput) emailInput.value = "";

    const snInput = this.querySelector('input[name="trade_sn"]');
    if (snInput) snInput.value = "";
    this.emailField.querySelector(".input-field").classList.remove("active");
    this.snField.querySelector(".input-field").classList.remove("active");
  }
  storeTradeInData(data) {
    // 存储折扣码到隐藏字段，以便后续使用
    const tradeinIdInput = this.querySelector('input[name="tradein-device"]');
    if (tradeinIdInput) {
      tradeinIdInput.value = data?.exchangeCouponCode || "";
      tradeinIdInput.dataset.devicePrice = Number(this.getDiscount());      document.dispatchEvent(new CustomEvent("tradein:change"));
    }
  }

  validateEmailFormat(input) {
    const email = input.value.trim();
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const valid_icon = this.querySelector(".valid-icon");
    // 如果输入为空且不是必填，不显示错误
    if (!email && this.emailField.style.display === "none") {
      return true;
    }

    // 如果输入为空但是必填，显示错误
    if (!email) {
      this.showApiError(this.errorTips?.emptyEmail);
      this.snSubmitBtn.style.display = "none";
      valid_icon.style.display = "none";
      return false;
    }

    // 检查邮箱格式
    if (!emailRegex.test(email)) {
      this.showApiError(this.errorTips?.invalidEmail);
      this.snSubmitBtn.style.display = "none";
      valid_icon.style.display = "none";
      return false;
    }

    // 清除错误提示
    this.removeError();
    this.snSubmitBtn.style.display = "flex";
    valid_icon.style.display = "block";
    return true;
  }

  async validateEmail(input) {
    if (!this.validateEmailFormat(input)) return false;
    const email = input.value.trim();

    try {
      const response = await this.checkEmailInDatabase(email);
      if (!response.exists) {
        this.showApiError(this.errorTips["emailNotFound"]);
        return false;
      }
      this.updateSubmitButtonState();
      return true;
    } catch (error) {
      console.error("Email validation error:", error);
      this.showApiError(this.errorTips["serverError"]);
      return false;
    }
  }

  async validateSN(input) {
    const sn = input.value.trim();
    input.value = sn.replace(/[^a-zA-Z0-9-#]/g, "");
    // 使用简单的 SN 格式验证
    return true;
  }
  validateSNFormat(input) {
    const sn = input.value.trim();

    // 如果输入为空，不显示错误
    if (!sn) {
      return false;
    }

    // 检查格式：只允许字母和数字
    const isValid = /^[A-Za-z0-9]+$/.test(sn);

    if (!isValid) {
      this.showApiError(this.errorTips.snInvalid);
      return false;
    }

    // 清除错误提示
    this.removeError();

    return true;
  }
  removeError() {
    const existingError = this.deviceVariant.querySelector(".error-message");
    if (existingError) {
      existingError.remove();
      const error_checkmark = document.querySelector(".trade-in-form .error_checkmark");
      error_checkmark.style.display = "none";
    }
  }
  // 替换原来的 validateSNFormat 方法
  validateSimpleSNFormat(sn) {
    // 简单验证：非空且只包含字母和数字
    return sn && /^[A-Za-z0-9]+$/.test(sn);
  }

  async checkEmailInDatabase(email) {
    return { exists: true };
  }

  async checkSNUsage(sn) {
    // TODO: Implement API call
    return false;
  }

  resetForm() {
    this.selectSelected.textContent = this.selectSelected.dataset.placeholder;
    this.selectSelected.removeAttribute("data-value");
    this.selectSelected.removeAttribute("data-price");

    if (this.tradeInForm) this.tradeInForm.reset();
  }
}

customElements.define("trade-in", TradeIn);

var SeelWidgetWatcher = class extends HTMLElement {
  connectedCallback() {
    this._observer = new MutationObserver((mutations) => {
      const relevant = mutations.some((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class" &&
          mutation.target.classList?.contains("seel_pdp_widget--option")
        )
          return true;
        if (mutation.type === "childList") {
          return Array.from(mutation.addedNodes).some(
            (n) =>
              n.nodeType === Node.ELEMENT_NODE &&
              (n.classList?.contains("seel_pdp_widget--option") || n.querySelector?.(".seel_pdp_widget--option")),
          );
        }
        return false;
      });
      if (!relevant) return;

      const widget = document.querySelector(".seel_pdp_widget");
      const hasSelected = !!widget?.querySelector(".seel_pdp_widget--option--selected");
      clearTimeout(this._seelTimer);
      const care = document.querySelector("care-sin");
      care?.remove();
      this._seelTimer = setTimeout(
        () => {
          const tradeIn = document.querySelector("trade-in");          if (tradeIn) tradeIn.updateProductPrice();
        },
        hasSelected ? 100 : 0,
      );
    });

    this._observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  disconnectedCallback() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
    clearTimeout(this._seelTimer);
  }
};

if (!window.customElements.get("seel-widget-watcher")) {
  window.customElements.define("seel-widget-watcher", SeelWidgetWatcher);
  document.body.appendChild(document.createElement("seel-widget-watcher"));
}
